import React, { useEffect, useState } from 'react';
import './SiteDetails.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../../Config';
import axios from 'axios';

const SiteDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const siteDetails = location.state?.siteDetails || null;

  const [formData, setFormData] = useState({
    clientName: siteDetails.clientName || '',
    siteName: siteDetails.siteName || '',
    siteAddress: siteDetails.siteAddress || '',
    siteMobile: siteDetails.siteMobile || '',
    siteEmail: siteDetails.siteEmail || '',
    manager: siteDetails.manager || '',
    work_type: siteDetails.work_type || '',
    reference_name: siteDetails.reference_name || '',
    date_of_birth: siteDetails.date_of_birth || '',
    contractNo: siteDetails.contractNo || '',
    registration_date: siteDetails.registration_date || '',
    interior_designer: siteDetails.interior_designer || '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const updateSiteDetails = async () => {
    try {
      const response = await axios.put(API_URL + `/client/${siteDetails.siteName}`, formData);

      if (response.status === 200) {
        console.log('Site details updated successfully');
        window.alert('Site details updated successfully!')
        navigate('/SiteDatabase')
      } else {
        console.error('Error updating user');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [clients, setClients] = useState([]);
  useEffect(() => {
    fetch(API_URL + '/client')
      .then(response => response.json())
      .then(data => setClients(data))
      .catch(error => console.error(error));
  }, []);

  let work_type_data;
  let manager_data;
  if(clients && clients.length > 0) {
     work_type_data = clients.map(user => user.work_type).filter((value, index, self) => self.indexOf(value) === index);
     manager_data = clients.map(user => user.manager).filter((value, index, self) => self.indexOf(value) === index);
  }

  return (
    <div>
      <SideMenuBar></SideMenuBar>

      <div class="content">
        <NewHeader></NewHeader>

        <div className='row2'>
          <h3 className='directory_Directory'>Site Database</h3>
        </div>

        <div class="row5_SiteDetails">
          <div class="row5_column1_SiteDetails">
            <p>Client Name</p>
            <input className='input_SiteDetails' placeholder='Client Name' name='clientName'
              value={formData.clientName}
              onChange={handleInputChange}></input>

            <p>Site Name</p>
            <input className='input_SiteDetails' placeholder='Site Name' name='siteName'
              value={formData.siteName}
              onChange={handleInputChange}></input>

            <p>Phone No.</p>
            <input className='input_SiteDetails' placeholder='Phone No.' name='siteMobile'
              value={formData.siteMobile}
              onChange={handleInputChange}></input>

            <p>Email ID</p>
            <input className='input_SiteDetails' placeholder='Email ID' name='siteEmail'
              value={formData.siteEmail}
              onChange={handleInputChange}></input>

            <p>Date of Birth</p>
            <input type="date" id="date" className='input_date' name='date_of_birth'
              value={formData.date_of_birth}
              onChange={handleInputChange} />

            <p>Registration Date</p>
            <input type="date" id="date" className='input_date' name='registration_date'
              value={formData.registration_date}
              onChange={handleInputChange} />

          </div>

          <div class="row5_column2_SiteDetails">

            <p>Work Type</p>
            <select className='select_SiteDetails' name='work_type'
              value={formData.work_type}
              onChange={handleInputChange}>
              <option value="" disabled hidden>Select</option>
              {work_type_data.map((workType, index) => (
                <option key={index} value={workType} className='options'>
                  {workType}
                </option>
              ))}
            </select>

            <p>Manager</p>
            <select className='select_SiteDetails' name='manager'
              value={formData.manager}
              onChange={handleInputChange}>
              <option value="" disabled hidden>Select</option>
              {manager_data.map((manager, index) => (
                <option key={index} value={manager} className='options'>
                  {manager}
                </option>
              ))}
            </select>

            <p>Contract No.</p>
            <div className='div_for_label_SiteDatabase'>
              <label>{formData.contractNo}</label>
            </div>

            <p>Referral Name</p>
            <input className='input_SiteDetails' placeholder='Referral Name' name='reference_name'
              value={formData.reference_name}
              onChange={handleInputChange}></input>

            <p>Interior Designer</p>
            <input className='input_SiteDetails' placeholder='Interior Designer' name='interior_designer'
              value={formData.interior_designer}
              onChange={handleInputChange}></input>

            <p>Address</p>
            <textarea className='address_input_SiteDetails' placeholder='Address' name='siteAddress'
              value={formData.siteAddress}
              onChange={handleInputChange}></textarea><br />
            <button className='update_btn_input_SiteDetails' onClick={updateSiteDetails}>Update</button>
          </div>
        </div>
        <br /><br />
      </div>
    </div>
  )
}

export default SiteDetails;